<template>
  <div class="feedback-submitted">
    <h1>{{ $t('feedbackSubmitted.heading', { businessName: review.businessName }) }}</h1>
    <p>{{ $t('feedbackSubmitted.msg') }}</p>
    <img class="mt-5 mb-5" :alt="$t('feedbackSubmitted.mailImgAlt')" src="../assets/img/mail.svg" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FeedbackSubmitted',
  computed: mapState({
    review: state => state.review,
  }),
};
</script>
